import request from '@/common/js/http'
import {SET_LOGINUSER} from "../mutation-types";

const weChat = {
    namespaced: true,
    state: {

        /*微信基础接口请求的access_token*/
        accessToken: '',

        /*微信网页授权登陆请求的access_token*/
        pageAccessToken: '',

        /*当前用户的openId*/
        openId: '',

        /*微信用户*/
        wechatUser: {}
    },
    getters: {
        currWeChatUser: state => {
            return state.wechatUser
        },
        CurrPageAccessToken: state => {

            return state.pageAccessToken
        },
        currAccessToken: state => {
            return state.accessToken
        },
        currOpenId: state => {
            if (state.wechatUser) {
                return state.wechatUser.openId
            }
            return ''
        }
    },
    mutations: {
        SET_CURR_WECHATUSER(state, user) {
            state.wechatUser = user
            if (user) {
                localStorage.setItem("wechatUser",JSON.stringify(user))
            }
        },
        SET_CURR_ACCESSTOKEN(state, accessToken) {
            state.accessToken = accessToken
        },
        SET_CURR_PAGEACCESSTOKEN(state, pageAccessToken) {
            state.pageAccessToken = pageAccessToken
        }
    },
    actions: {
        getPageAccessToken({commit}, code) {
            return new Promise((resolve, reject) => {
                return request({
                    url: 'weChat/pageAccessToken',
                    method: 'GET',
                    params: {code: code}
                }).then(response => {
                    resolve(response)
                    console.log(response)
                    if (response && response.data) {
                        commit('SET_CURR_PAGEACCESSTOKEN', response.data)
                        localStorage.setItem("openId", response.data.openId)
                    }
                }, error => {
                    reject(error)
                })
            })
        },
        getUserInfo({commit}, {openId, code}) {
            return new Promise((resolve, reject) => {
                return request({
                    url: 'weChat/userInfo',
                    method: 'POST',
                    data: {openId: openId, code: code}
                }).then(response => {
                    resolve(response)
                    console.log(response)
                    if (response && response.data.weChatUserInfo) {
                        commit('SET_LOGINUSER', {yc_token: response.data.token, employee: response.data.data})
                        commit('SET_CURR_WECHATUSER',response.data.weChatUserInfo)
                    }
                }, error => {
                    reject(error)
                })
            })

        }
    }
}

export default weChat



// WEBPACK FOOTER //
// ./src/vuex/modules/wechat.js